import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";
import { inviteCircles } from "../domain/circles/circleAccess";
import { useCircles } from "./useCircles";

export function useAvailableInviteCircles() {
  const { user } = useAuth();
  const { data: circles = [], isLoading } = useCircles();

  const availableCircles = useMemo(
    () => inviteCircles(circles, user),
    [circles, user]
  );

  return { availableCircles, isLoading };
}
